/**
 * Controller: membershipLevelsSidebar
 */
angular.module('acme.view.application.membership.levels.sidebar.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.service.viewState'
])
.controller('MembershipLevelsSidebarController', [ '$scope', '$state', '$timeout', 
'ApiService', 
'HelpersService', 
'PermissionsService', 'ViewStateService', 
function($scope, $state, $timeout, 
ApiService, 
HelpersService, 
PermissionsService, 
ViewStateService) {

    $scope.membershipLevelsSidebar = {

      auxiliaryGroups: [],

      defaultGroup: {
        name: 'None',
        displayOrder: 0,
        locked: true,
        id: ''
      },

      namePrefix: 'Untitled Group',
      
      groupSortableOptions: {

        axis: 'y',

        update: function(e, ui) {
          $scope.membershipLevelsSidebar.onGroupSortableUpdate(e, ui);
        },
        cancel: 'li.not-sortable',
        items: '> li:not(.not-sortable)',
        disabled: true
      },

      showGroups: false,

      selectedGroup: false,

      init: function() {
        if (PermissionsService.check('MEMBERSHIP_LEVEL_COLLECTION_UPDATE')) {
          this.groupSortableOptions.disabled = false;
        }
        this.getGroups();
        $scope.$on('MembershipLevelsSidebar::Delete', this.onDeleteGroup);
        $scope.$on('MembershipLevelsSidebar::Save', this.onSaveGroup);
        $scope.$on('MembershipLevelsSidebar::Reset', this.onReset);
      },

      getGroups: function(group) {
        ApiService.membership.categories.collection.list(HelpersService.getPaginator({ sortField: 'name', sortDirection: 'asc' })).then(this.success.getGroups, this.error.getGroups);
      },

      isSelected: function(groupId) {
        var  defaultSelection = !groupId && !this.selectedGroup;
        return defaultSelection ? true : (this.selectedGroup && (groupId === this.selectedGroup.id));
      },

      selectGroup: function (id, force) {
        var found;

        if (!this.isSelected(id)) {

          found = this.findAuxiliaryGroups(id);

          if (found) {
            this.selectedGroup = found.group;
            $scope.$emit('MembershipLevelsSidebar::Select', {
              group: this.selectedGroup
            });
          } else {
            this.selectedGroup = false;
            $scope.$emit('MembershipLevelsSidebar::Select');
          }
        }

      },

      create: function() {
        var group = {
          name: this.namePrefix + ' ' + (this.auxiliaryGroups.length+1)
        };
        ApiService.membership.categories.collection.create(group).then(this.success.create, this.error.create);
      },

      update: function() {
        if (this.selectedGroup) {
          ApiService.membership.categories.collection.update(this.selectedGroup).then(this.success.update, this.error.update);
        }
      },

      remove: function(id) {
        //TODO: Add remove confirmation modal
        ApiService.membership.categories.collection.remove(id).then(this.success.remove, this.error.remove);
      },

      findAuxiliaryGroups: function(id) {
        var i, ii,
            r = false,
            self = $scope.membershipLevelsSidebar;
      
        for (i=0,ii=self.auxiliaryGroups.length;i<ii;i++) {
          if (self.auxiliaryGroups[i].id === id) { 
            r = {
              group: self.auxiliaryGroups[i],
              index: i
            };
            break;
          }
        }
        
        return r;
      },

      moveGroup: function(id, direction) {
        var found = this.findAuxiliaryGroups(id);
        if (found !== false) {
          this['moveGroup' + HelpersService.cap(direction)](found.index);
        }
      },

      moveGroupUp: function(index) {
        var i, ii,
            tmp,
            props = [];

        if (index > 0) {
          tmp = this.auxiliaryGroups.splice(index, 1)[0];
          this.auxiliaryGroups.splice(index - 1, 0, tmp);
        }
        for (i=0,ii=this.auxiliaryGroups.length;i<ii;i++) {
          this.auxiliaryGroups[i].displayOrder = i + 1;
          if (!this.auxiliaryGroups[i].locked) {
            props.push({
              id: this.auxiliaryGroups[i].id,
              displayOrder: this.auxiliaryGroups[i].displayOrder,
              name: this.auxiliaryGroups[i].name
            });
          }
        }

        if (props instanceof Array && props.length) {
          ApiService.membership.categories.collection.updateDisplayOrder(props).then(this.success.moveGroup, this.error.moveGroup);
        }

      },

      moveGroupDown: function(index) {
        var i, ii,
            tmp,
            props = [];

        if (index < this.auxiliaryGroups.length - 1) {
          tmp = this.auxiliaryGroups.splice(index, 1)[0];
          this.auxiliaryGroups.splice(index + 1, 0, tmp);
        }
        for (i=0,ii=this.auxiliaryGroups.length;i<ii;i++) {
          this.auxiliaryGroups[i].displayOrder = i + 1;
          if (!this.auxiliaryGroups[i].locked) {
            props.push({
              id: this.auxiliaryGroups[i].id,
              displayOrder: this.auxiliaryGroups[i].displayOrder,
              name: this.auxiliaryGroups[i].name
            });
          }
        }

        if (props instanceof Array && props.length) {
          ApiService.membership.categories.collection.updateDisplayOrder(props).then(this.success.moveGroup, this.error.moveGroup);
        }
      },

      moveGroupSort: function() {
        var i, ii,
            props = [];

        for (i = 0, ii = this.auxiliaryGroups.length; i < ii; i++) {
          this.auxiliaryGroups[i].displayOrder = i + 1;
          if (!this.auxiliaryGroups[i].locked) {
            props.push({
              id: this.auxiliaryGroups[i].id,
              displayOrder: this.auxiliaryGroups[i].displayOrder,
              name: this.auxiliaryGroups[i].name
            });
          }
        }

        if (props instanceof Array && props.length) {
          ApiService.membership.categories.collection.updateDisplayOrder(props).then(this.success.moveGroup, this.error.moveGroup);
        }
      },

      success: {
        getGroups: function(response) {
          var self = $scope.membershipLevelsSidebar, 
              groupId = ViewStateService.getStateProperty('membership.levels', 'groupId');
          self.auxiliaryGroups = [self.defaultGroup].concat(response.data.payload.list);
          if (groupId) {
            self.selectGroup(groupId);
          }
        },
        create: function(response) {
          var self = $scope.membershipLevelsSidebar;
          self.auxiliaryGroups.push(response.data.payload);
          self.selectGroup(response.data.payload.id);
        },
        update: function(response) {
          $scope.$emit('MembershipLevelsSidebar::Success');
        },
        moveGroup: function(response) {},
        remove: function(response) {
          var self = $scope.membershipLevelsSidebar,
            found = self.findAuxiliaryGroups(self.selectedGroup.id),
            selectNextIndex;
          if (found) {
            self.auxiliaryGroups.splice(found.index, 1);
            selectNextIndex = found.index > 0 ? found.index - 1 : 0;
            self.selectGroup(self.auxiliaryGroups[selectNextIndex].id);
          }
          $scope.$emit('MembershipLevelsSidebar::Success');
        }
      },

      error: {
        init: function(response) {},
        getGroups: function(response) {},
        create: function(response) {
          $scope.$emit('MembershipLevelsSidebar::Error', response);
        },
        update: function(response) {
          $scope.$emit('MembershipLevelsSidebar::Error', response);
        },
        move: function(response) {},
        remove: function(response) {
          $scope.$emit('MembershipLevelsSidebar::Error', response);
        }
      },

      onGroupSortableUpdate: function(e, data) {
        // next tick
        $timeout(function() {
          $scope.membershipLevelsSidebar.moveGroupSort();
        }, 0);
      },

      onDeleteGroup: function(e, data) {
        var self = $scope.membershipLevelsSidebar,
            groupId = data && data.id;

        if (groupId) {
          self.remove(groupId);
        }
      },

      onSaveGroup: function(e, data) {
        var self = $scope.membershipLevelsSidebar,
            found;

        if (data && data.group && data.group.id) {
          found = self.findAuxiliaryGroups(data.group.id);
          if (found) {
            self.selectedGroup = data.group;
            self.update();
          }
        }
      },
      
      onReset: function(e, data) {
        $scope.membershipLevelsSidebar.selectGroup();
      }

    };

    $scope.membershipLevelsSidebar.init();

}]);
